import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import env from 'misc/env';
import LaunchDarkly from 'launchdarkly-js-client-sdk';
import memoize from 'memoizee';
import axios from 'axios';

/**
 * Memoized toggle client factory
 * to be used across the app to get
 * the client instance
 */
export var getFeatureToggleClient = memoize(function () {
  return createFeatureToggleClient();
});

/**
 * Memoized initializer.
 * In prod-like envs this makes sure LaunchDarkly is ready.
 * In local env it makes sure we've fetched the flag values
 * from the local feature toggle store
 */
export var initializeToggleClient = memoize(/*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(client) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return client.waitForInitialization();
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x) {
    return _ref.apply(this, arguments);
  };
}());

/**
 * Factory function that creates the correct feature toggle client
 */
function createFeatureToggleClient() {
  if (env.LAUNCHDARKLY_CLIENT_KEY) {
    var anonymousUser = {
      key: 'anonymous',
      anonymous: true
    };
    var ldClient = LaunchDarkly.initialize(env.LAUNCHDARKLY_CLIENT_KEY, anonymousUser);
    return ldClient;
  } else {
    return new LocalLDClient();
  }
}

/**
 * LocalLDClient basically mirrors the main usecases from
 * the LaunchDarkly client. We use this for local development
 * by querying a dev-only route that leverages our local redis
 * feature toggle store
 */

export var LocalLDClient = /*#__PURE__*/function () {
  function LocalLDClient() {
    var flagValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, LocalLDClient);
    this.flagValues = flagValues;
  }
  return _createClass(LocalLDClient, [{
    key: "variation",
    value: function variation(key) {
      var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var flagExists = Object.prototype.hasOwnProperty.call(this.flagValues, key);
      if (!flagExists) {
        return defaultValue || false;
      }
      return this.flagValues[key];
    }
  }, {
    key: "identify",
    value: function identify(user) {
      return {};
    }
  }, {
    key: "allFlags",
    value: function allFlags() {
      return this.flagValues;
    }
  }, {
    key: "waitForInitialization",
    value: function () {
      var _waitForInitialization = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var fetchedResp, fetchedVals;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return axios.get('/__featureToggles');
            case 3:
              fetchedResp = _context2.sent;
              fetchedVals = fetchedResp.data;
              this.flagValues = fetchedVals;
              _context2.next = 11;
              break;
            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](0);
              console.error('Error initializing local LaunchDarkly client', _context2.t0);
            case 11:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 8]]);
      }));
      function waitForInitialization() {
        return _waitForInitialization.apply(this, arguments);
      }
      return waitForInitialization;
    }()
  }]);
}();
//# sourceMappingURL=featureToggles.js.map
